import React, { useState, useEffect } from "react";
import {
  Button,
  FormFieldSet,
  Modal,
  PageTitle,
  showToast,
  TableAdv,
  Backdrop,
  LogoLoader,
} from "../../../../components";
import { useNavigate } from "react-router-dom";
import { keyToTitle, mapTableRows } from "../../../../utils";
import { DocumentDrawer } from "../../../../components/Onboarding/drawer/DocumentDrawer";
import { onboardingDocumentCategory } from "../../../../assets/data/enumData";
import { DocumentPreview } from "../../../../components/Onboarding/document/DocumentPreview";
import { getPresignedUrl } from "../../../../redux/slices/universal/fileUploadApi";
import { updatePdfTemplate } from "../../../../redux/slices/onboarding/onboardingApi";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import { useCallback } from "react";
import { cloneDeep } from "lodash";

const AddChecklist = ({
  selectedType,
  onboardingId,
  employeeId,
  onboardingDoc,
  formData,
  handleChange,
  errors,
  handleSubmit,
}) => {
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewDrawerOpen, setViewDrawerOpen] = useState(false);
  const [workflows, setWorkflows] = useState([
    { initiator: [], approvers: [] },
  ]);
  const [loading, setLoading] = useState(false);
  const [currentDocument, setCurrentDocument] = useState(null);
  const [originalDocument, setOriginalDocument] = useState(null);
  const [currentRowData, setCurrentRowData] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  function canSaveChecklistItem(rowData) {
    const fieldsByPage = rowData?.metaData?.id?.fields;

    if (!fieldsByPage || typeof fieldsByPage !== "object") {
      return false;
    }

    for (const pageFields of Object.values(fieldsByPage)) {
      for (const field of pageFields) {
        if (field.required === true && field.role === "initiator") {
          const value = field.value;

          if (
            value === undefined ||
            value === null ||
            (typeof value === "string" && value.trim() === "")
          ) {
            return false;
          }
        }
      }
    }

    return true;
  }

  // Check if required fields are filled

  const columns = [
    {
      key: "documentCategory",
      label: "Document Category",
      columnMenu: false,
      render: (row) =>
        onboardingDocumentCategory?.find(
          (a) => a.value === row.documentCategory,
        )?.label || "-",
    },
    {
      key: "document",
      label: "Document",
      columnMenu: false,
    },
    {
      key: "dueDate",
      label: "Due Date",
      columnMenu: false,
      render: (row) => (
        <FormFieldSet
          type="datepicker"
          noTitle
          placeholder="Select date"
          value={row?.dueDate || ""}
          onChange={(value) => {
            setRows((prev) =>
              prev?.map((item, i) =>
                item.id === row.id ? { ...item, dueDate: value } : item,
              ),
            );
          }}
          showDropdown={false}
        />
      ),
    },
    {
      key: "approvers",
      label: "Approvers",
      columnMenu: false,
      render: (row) => (
        <div className="w-50">
          <FormFieldSet
            type="usersForEonboarding"
            noTitle
            placeholder="Select"
            value={row?.approvers || ""}
            multiple
            onChange={(value) => {
              setRows((prev) =>
                prev?.map((item, i) =>
                  item.id === row.id ? { ...item, approvers: value } : item,
                ),
              );
            }}
          />
        </div>
      ),
    },
    {
      key: "comments",
      label: "Comments",
      columnMenu: false,
      render: (row) => (
        <FormFieldSet
          type="text"
          noTitle
          placeholder=""
          value={row?.comments || ""}
          onChange={(value) => {
            setRows((prev) =>
              prev?.map((item, i) =>
                item.id === row.id ? { ...item, comments: value } : item,
              ),
            );
          }}
        />
      ),
    },
    {
      key: "sendMail",
      label: "Send Mail",
      columnMenu: false,
      render: (row) => (
        <FormFieldSet
          type="checkbox"
          noTitle
          options={[{ label: "", value: "1" }]}
          values={row?.sendMail || ""}
          onChange={(value) => {
            setRows((prev) =>
              prev?.map((item, i) =>
                item.id === row.id ? { ...item, sendMail: value } : item,
              ),
            );
          }}
        />
      ),
    },
    {
      key: "actions",
      label: "Actions",
      columnMenu: false,
      render: (row) => {
        const isFieldsFilled = canSaveChecklistItem(row);

        return (
          <div className="flex items-center gap-2">
            <Button
              type="icon"
              variant="text"
              icon={"edit_square"}
              color={isFieldsFilled ? "success" : "danger"}
              size="sm"
              onClick={() => handleDocumentPreview(row)}
            />
            <Button
              type="icon"
              variant="text"
              icon={"person_add"}
              // color="danger"
              size="sm"
              onClick={() => handleOpenWorkflowDrawer(row)}
            />
          </div>
        );
      },
    },
  ];

  //working one
  // useEffect(() => {
  //   setRows(
  //     formData?.checklistItems?.map((data) => {
  //       console.log({dataForRow:data})
  //       return {
  //         id: data?._id || "",
  //         approvers: data?.approver || [],
  //         documentCategory: data?.id?.category || "-",
  //         document: data?.id?.name || "",
  //         dueDate: data?.dueDate || "",
  //         comments: data?.comment || "",
  //         sendMail: data?.mail ? "1" : "",
  //         metaData: data,
  //       };
  //     }),
  //   );
  // }, [formData?.checklistItems]);
  //
  // tetsing one 18-12
  useEffect(() => {
    //if multiple checklists added this api structure will change
    setRows(
      formData?.checklistItems?.map((data) => {
        const valueMap = (data?.fields || []).reduce((acc, { id, value }) => {
          acc[id] = value;
          return acc;
        }, {});

        const mappedFields = Object.fromEntries(
          Object.entries(data?.id?.fields || {}).map(([page, fieldArray]) => [
            page,
            fieldArray.map((field) => ({
              ...field,
              value: valueMap[field.id] ?? field.value,
            })),
          ]),
        );

        const normalizedMetaData = {
          ...data,
          id: {
            ...data.id,
            fields: mappedFields,
          },
        };

        return {
          id: data?._id || "",
          approvers: data?.approver || [],
          initiator: data?.initiator || undefined,
          documentCategory: data?.id?.category || "-",
          document: data?.id?.name || "",
          dueDate: data?.dueDate || "",
          comments: data?.comment || " ",
          sendMail: data?.mail ? "1" : "",
          metaData: normalizedMetaData,
        };
      }) || [],
    );
  }, [formData?.checklistItems]);

  useEffect(() => {
    handleChange("updatedChecklistsForSave", rows);
  }, [rows]);

  const handleDocumentPreview = async (row) => {
    try {
      const initiatorToConsider =
        row?.initiator?.value ??
        row?.initiator?.uiid ??
        row?.metaData?.id?.initiator?.uiid;
      console.log({
        handleDocumentPreview: row,
        loginUserUiid,
        initiatorToConsider,
      });
      if (loginUserUiid !== initiatorToConsider) {
        showToast("You are not an Initiator to fill details.", "warning", 5000);
        return;
      }
      setLoading(true);

      const docMetadata = row?.metaData?.id;

      if (!docMetadata?.file) {
        showToast("No File Found!", "error");
        return;
      }

      const presignedUrl = await getPresignedUrl(docMetadata.file);
      const response = await fetch(presignedUrl, {
        mode: "cors",
      });
      const urlDataInBlob = await response.blob();
      const arrayBuffer = await urlDataInBlob.arrayBuffer();

      const documentForPreview = {
        id: docMetadata._id,
        referenceId: docMetadata.templateId,
        documentName: docMetadata.name,
        category: docMetadata.category,
        type: docMetadata.type,
        description: docMetadata.description,
        toBeFilledBy: docMetadata.filledBy,
        createdBy: `User`,
        createdOn: docMetadata.addedOn,
        workflows: [
          {
            approvers: {
              label: docMetadata.approver,
              value: docMetadata.approver,
            },
            initiator: {
              label: docMetadata.initiator,
              value: docMetadata.initiator,
            },
          },
        ],
        arrayBuffer,
        pageCount: docMetadata.pageCount,
        droppedFields: docMetadata.fields || {},
        status: docMetadata.status,
        metaData: docMetadata,
      };
      setOriginalDocument(JSON.parse(JSON.stringify(documentForPreview)));
      setCurrentDocument(documentForPreview);
      setCurrentRowData(row);
      setHasUnsavedChanges(false);
      setViewModalOpen(true);
    } catch (error) {
      console.error("Error in handleDocumentPreview", error);
      showToast("Failed to load document preview", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenWorkflowDrawer = (row) => {
    console.log({ handleOpenWorkflowDrawer: row });
    //initial document populated from pdf templates
    const docMetadata = row?.metaData?.id;

    setCurrentRowData(row);
    // setCurrentDocument({
    //   id: docMetadata._id,
    //   uiid: docMetadata._id,
    //   documentName: docMetadata.name,
    //   toBeFilledBy: docMetadata.filledBy,
    //   category: docMetadata.category,
    //   type: docMetadata.type,
    //   description: docMetadata.description,
    // });
    const initiatorData = row?.initiator
      ? row?.initiator
      : docMetadata?.initiator;
    console.log({ initiatorData });
    setWorkflows([
      {
        initiator: {
          label: `${initiatorData?.firstName || ""} ${
            initiatorData?.lastName || initiatorData?.label || ""
          }`.trim(),
          value: initiatorData?.uiid || initiatorData?.value,
        },
      },
    ]);

    setViewDrawerOpen(true);
  };

  // const handleSaveWorkflow = useCallback(async () => {
  //   setLoading(true);

  //   try {
  //     console.log("workflows",workflows)
  //     console.log("currentroe",currentRowData)
  //     if (!workflows?.length || !currentRowData?.id) {
  //       throw new Error("Invalid workflow or row data");
  //     }

  //     const initiatorId = workflows[0]?.initiator?.value;
  //     if (!initiatorId) {
  //       throw new Error("Missing initiatorId");
  //     }

  //     const currentChecklistId = currentRowData.id;

  //     console.log({rows})
  //     setRows((prev) =>
  //       prev?.map((row) =>
  //         row.id === currentChecklistId
  //           ? { ...row, initiator: initiatorId }
  //           : row,
  //       ),
  //     );

  //     setViewDrawerOpen(false);
  //     setCurrentRowData(null);
  //     setWorkflows([]);
  //   } catch (error) {
  //     console.error("Error in handleSaveWorkflow", error);
  //     showToast("Something Went Wrong", "error");
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [
  //   workflows,
  //   currentRowData,
  //   formData.updatedChecklistsForSave,
  //   handleChange,
  // ]);
  //
  const handleSaveWorkflow = useCallback(() => {
    setLoading(true);

    try {
      if (!Array.isArray(workflows) || workflows.length === 0) {
        throw new Error("Workflows are empty or invalid");
      }

      if (!currentRowData?.id) {
        throw new Error("Current row data is missing");
      }

      const initiatorId = workflows[0]?.initiator;
      if (!initiatorId) {
        throw new Error("Initiator ID is missing");
      }

      const checklistId = currentRowData.id;

      let rowUpdated = false;
      const newRows = rows?.map((row) => {
        if (row.id == checklistId) {
          rowUpdated = true;
          return { ...row, initiator: initiatorId };
        }
        return row;
      });
      setRows(newRows);

      if (!rowUpdated) {
        throw new Error("Checklist row not found");
      }

      setViewDrawerOpen(false);
      setCurrentRowData(null);
      setWorkflows([]);
    } catch (error) {
      console.error("handleSaveWorkflow failed:", error);
      showToast(
        error instanceof Error ? error.message : "Something went wrong",
        "error",
      );
    } finally {
      setLoading(false);
    }
  }, [workflows, currentRowData, setRows]);

  // Update field value directly in currentDocument state
  const handleUpdateField = (fieldId, value, userId = null) => {
    setCurrentDocument((prevDoc) => {
      if (!prevDoc) return prevDoc;

      // const updatedFields = { ...prevDoc.droppedFields };
      const updatedFields = cloneDeep(prevDoc.droppedFields);
      let fieldFound = false;

      Object.keys(updatedFields).forEach((pageNum) => {
        updatedFields[pageNum] = updatedFields[pageNum].map((field) => {
          if (field.id !== fieldId) return field;

          fieldFound = true;
          if (!field.value || typeof field.value !== "object") {
            field.value = {};
          }
          field.value = value;

          return { ...field };
        });
      });

      if (!fieldFound) {
        console.warn(`Field ${fieldId} not found in document`);
      }

      return {
        ...prevDoc,
        droppedFields: updatedFields,
      };
    });

    setHasUnsavedChanges(true);
  };

  const handleSaveDocument = useCallback(async () => {
    try {
      setLoading(true);
      const currentDocumentChanges = { ...currentDocument };
      const currentDocumentId = currentDocumentChanges?.id;
      if (!currentDocumentId) {
        throw new Error(
          "There is no Id in the currentDocumentChanges in handleSaveDocument",
        );
      }
      const newDroppedFields = { ...currentDocumentChanges.droppedFields };

      const duplicateRows =
        rows?.map((data) => {
          if (currentDocumentId === data.metaData?.id?._id) {
            return {
              ...data,
              metaData: {
                ...data.metaData,
                id: {
                  ...data.metaData.id,
                  fields: { ...newDroppedFields },
                },
              },
            };
          }

          return data;
        }) || [];

      // console.log({ duplicateRows, newDroppedFields, rows, currentDocumentId });
      setRows(duplicateRows);
      setHasUnsavedChanges(false);
      setViewModalOpen(false);
      setCurrentDocument(null);
    } catch (error) {
      let errorMessage = error?.message;
      console.error(
        errorMessage ? errorMessage : "Error saving document:",
        error,
      );
      showToast("Something went wrong", "error");
      return null;
    } finally {
      setLoading(false);
    }
  }, [rows, currentDocument]);

  const handleCancelDocument = () => {
    if (hasUnsavedChanges) {
      setCurrentDocument(JSON.parse(JSON.stringify(originalDocument)));
      setHasUnsavedChanges(false);
    }

    setViewModalOpen(false);
    setCurrentDocument(null);
    setCurrentRowData(null);
    setOriginalDocument(null);
  };

  const mappedRows = mapTableRows(rows, columns);

  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-col items-start gap-3 px-4">
        <PageTitle title={`${keyToTitle(selectedType)} Checklist`} />
      </div>
      <div className="px-3 py-2 grid grid-cols-2 gap-4 lg:w-[75%] w-full">
        <FormFieldSet
          type="datepicker"
          title="Onboard Due"
          placeholder="Select Date"
          value={formData.onboardDue || ""}
          onChange={(value) => handleChange("onboardDue", value)}
          showDropdown={false}
        />
      </div>

      <div className="flex flex-col">
        <div className="m-2 px-3 py-2 border border-gray-100 rounded-lg shadow">
          <div className="flex justify-between items-center">
            <div className="grid grid-cols-2 gap-4 lg:w-[75%] w-full">
              <FormFieldSet
                type="checklistsWithEntityFilter"
                title="Onboard Checklist"
                placeholder="select"
                value={formData.onboardChecklist || ""}
                onChange={(value) => {
                  handleChange("onboardChecklist", value);
                  handleChange(
                    "checklistItems",
                    value?.metaData?.documents || [],
                  );
                }}
                filters={{ entityFilter: onboardingDoc?.entity?.type }}
              />

              <FormFieldSet
                type="datepicker"
                title="Due Date"
                placeholder="Select Date"
                value={formData.dueDate || ""}
                onChange={(value) => handleChange("dueDate", value)}
                showDropdown={false}
              />
            </div>
          </div>

          {rows && rows?.length > 0 && (
            <div className="mt-3">
              <TableAdv
                columns={columns}
                rows={mappedRows}
                hideToolBar={true}
              />
            </div>
          )}
        </div>
      </div>

      <div className="flex justify-end gap-4 me-10 mt-15 mb-10">
        <Button
          title={"Cancel"}
          variant="outlined"
          onClick={() => navigate("/e-onboarding#dashboard/initiated")}
        />
        <Button
          title={"Save as Draft"}
          onClick={() => handleSubmit(2)}
          variant="outlined"
        />
        <Button title={"Save"} onClick={() => handleSubmit(null)} />
        <Button title={"Initiate"} onClick={() => handleSubmit(3)} />
      </div>

      <Modal
        isOpen={viewModalOpen}
        closeOnOutsideClick={false}
        showCloseButton={false}
        width="w-full h-full"
      >
        {currentDocument && (
          <>
            <div className="flex flex-col gap-4 bg-[#F9F9F9] py-3 mb-5">
              <div className="rounded-lg px-6 pt-2">
                <div className="flex items-center justify-between">
                  <div className="flex gap-3">
                    <Button
                      icon={"picture_as_pdf"}
                      variant="text"
                      size="xl"
                      color="black"
                      className="!px-2"
                    />

                    <div>
                      <div className="font-medium gap-2">
                        {currentDocument.documentName} -{" "}
                        {currentDocument.referenceId}
                        {/* {hasUnsavedChanges && (
                          <span className="ml-2 text-sm text-orange-600">
                            (Unsaved changes)
                          </span>
                        )} */}
                      </div>

                      <div className="text-sm text-gray-600 mt-2">
                        <span className="text-neutrals-400">Category: </span>
                        <span className="font-semibold">
                          {onboardingDocumentCategory?.find(
                            (a) => a.value === currentDocument.category,
                          )?.label || "-"}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center justify-center gap-3">
                    <Button
                      title={"Cancel"}
                      variant="outlined"
                      className="!py-1 !px-4"
                      onClick={handleCancelDocument}
                    />
                    <Button
                      title={"Save Document"}
                      variant="contained"
                      className="!py-1 !px-4"
                      onClick={handleSaveDocument}
                      disabled={!hasUnsavedChanges}
                    />
                  </div>
                </div>
              </div>
            </div>

            <DocumentPreview
              document={currentDocument}
              mode="initiator"
              userId={String(loginUserUiid)}
              userRole="initiator"
              onUpdateField={handleUpdateField}
            />
          </>
        )}
      </Modal>

      <DocumentDrawer
        open={viewDrawerOpen}
        step="workflow"
        workflows={workflows}
        onWorkflowsChange={setWorkflows}
        onClose={() => {
          setViewDrawerOpen(false);
          setCurrentDocument(null);
          setCurrentRowData(null);
          setWorkflows([{ initiator: null, approvers: null }]);
        }}
        onProceed={handleSaveWorkflow}
        workflowTargetDoc={currentDocument}
        // multiple
        hideApprovers={true}
      />

      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default AddChecklist;
